import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setMemberToken } from '../lib/memberToken';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id in URL');
          // Redirect to home instead of login - site is public
          navigate('/', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing session_id...');

        // Exchange session_id for user data + session_token
        const response = await fetch(`${API_URL}/api/auth/google/callback`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Authentication failed');
        }

        const userData = await response.json();
        console.log('✅ Google Sign-In successful');
        if (userData.member_token) setMemberToken(userData.member_token);

        // Full reload so the access tier + SW API cache reflect the new session.
        try {
          const keys = await caches.keys();
          await Promise.all(keys.filter((k) => k.endsWith('-api')).map((k) => caches.delete(k)));
        } catch { /* noop */ }
        window.location.replace('/');

      } catch (error) {
        console.error('Auth callback error:', error);
        // Redirect to home with optional error message - site is public
        navigate('/', {
          replace: true,
          state: { authError: error.message }
        });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)'
    }}>
      <div style={{ textAlign: 'center', color: '#fff' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255,255,255,0.1)',
          borderTop: '4px solid #FFD700',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }} />
        <p style={{ fontSize: '18px', color: '#94a3b8' }}>Completing sign-in...</p>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AuthCallback;
